import VideoWizardObjectiveStep, {
  VideoWizardObjectiveStepProps,
} from './VideoWizardObjectiveStep';

export default VideoWizardObjectiveStep;
export { VideoWizardObjectiveStepProps };
